// @deprecated
enum ModalTypes {
    STANDARD = 'standard',
    SECONDARY = 'secondary',
    INFORMATION_SUCCESS = 'information-success',
}

export default ModalTypes;
